import { combineReducers } from 'redux';

//import agentSurvey from './screens/Surveys/AgentSurvey/AgentSurveyReducers';
import customerFacingSurvey from './screens/_v3/Surveys/CustomerFacingSurvey/CustomerFacingSurveyReducers';
//import qaSurvey from './screens/Surveys/QaSurvey/QaSurveyReducers';
import hiddenEndpoints from './screens/hiddenEndpointsReducers';
import ImageCropper from './components/ImageCropper/ImageCropperReducers';

import session from './sessionReducers';
import SurveyActivityScreen from './screens/_v3/SurveyActivity/SurveyActivityScreenReducers';
import CalibrationV3Screen from './screens/_v3/CalibrationScreenV3/CalibrationV3ScreenReducers';
import SurveysScreen from './screens/_v3/AdminScreenV3/SurveysScreen/SurveysScreenReducers';
import TeamsScreen from './screens/_v3/AdminScreenV3/TeamsScreen/TeamsScreenReducers';
import UsersScreen from './screens/_v3/AdminScreenV3/UsersScreen/UsersScreenReducers';
import SystemDashboardScreenV3 from './screens/_v3/SystemDashboardScreenV3/SystemDashboardV3ScreenReducers';
import QaDashboardManagerScreen from './screens/_v3/QaDashboardScreenV3/QaDashboardScreenReducers';
import CoachingDashboardScreen from './screens/_v3/CoachingDashboardV3/CoachingDashboardReducers';

import AgentSurveyScreen from './screens/_v3/Surveys/AgentSurvey/AgentSurveyScreenReducers';
import ComcastLiveAgentSurveyScreen from './screens/_v3/LiveSurveys/ComcastLiveAgentSurveyScreenReducers';
import TeamDashboardScreen from './screens/_v3/TeamDashboardScreen/TeamDashboardScreenReducers';

export default combineReducers({
    hiddenEndpoints,
    ImageCropper,
    session,
    SurveyActivityScreen,
    QaDashboardManagerScreen,
    CalibrationV3Screen,
    SurveysScreen,
    TeamsScreen,
    UsersScreen,
    SystemDashboardScreenV3,
    customerFacingSurvey,
    AgentSurveyScreen,
    CoachingDashboardScreen,
    ComcastLiveAgentSurveyScreen,
    TeamDashboardScreen,
});